module.exports = __webpack_public_path__ + "img/telescope.060b204c.svg";